
import { format } from 'timeago.js';
import numeral from 'numeral';
import { viewIcon, likeIcon, commentIcon } from '../../utils/icons';

const VideosInfo = ({ snippet, statistics, attributes }) => {

    const { info } = attributes;
    const { isView, isLike, isComment, isPDate, iconSize, iconColor } = info;
    const { viewCount, likeCount, commentCount } = statistics || '';
    const { publishTime } = snippet;

    window.format = format;
    const formattedNumber = numeral(viewCount).format('0.0a');
    return <div className='videosInfo'>

        {isView && <div className="viewCount">
            {viewIcon(iconSize, iconColor)}
            <span>{formattedNumber}</span>
        </div>}

        {isLike && <div className="likeCount">
            {likeIcon(iconSize, iconColor)}
            <span>{likeCount}</span>
        </div>}

        {isComment && <div className="commentCount">
            {commentIcon(iconSize, iconColor)}
            <span>{commentCount}</span>
        </div>}

        {isPDate && <div className='publishDate' >
            <span>{publishTime?.includes('ago') ? publishTime : format(publishTime)}</span>
        </div>}

    </div>
}
export default VideosInfo;